import { Component, OnInit } from '@angular/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { MenuTreeItem } from '../../core/services/menu/menu-tree-item';
import { AppMenuService } from '../../core/services/menu/app-menu.service';
import { AbstractComponent } from '../../shared/components/abstract-component/abstract.component';
import { FormatConfigService } from '../../core/services/format-config.service';
import { AppImageConfig } from '../../core/services/app-image-config';
import { Router, RouterOutlet } from '@angular/router';
import { ImageConfigEntry } from '../../core/base-api';
import { HeaderComponent } from '../../core/extension/header/cap-header.component';
import { UserPickerComponent } from '../../core/extension/user-picker/user-picker.component';
import { EnvironmentMarkerComponent } from '../environment-marker/environment-marker.component';
import { NavMenuComponent } from '../../core/extension/navigation/cap-nav-menu.component';
import { CapNavItemComponent } from '../../core/extension/navigation/cap-nav-item.component';
import { NgClass, NgStyle } from '@angular/common';
import { CapAlertListComponent } from '../../core/extension/exceptions/cap-alert-list.component';
import { FormsModule } from '@angular/forms';
import { SearchbarComponent } from './searchbar/searchbar.component';
import { TranslatePipe } from '@ngx-translate/core';
import { CapiLoginService } from '../../core/extension/login/capi-login-service';

@Component({
  selector: 'cap-intercapi-public-layout',
  styleUrls: ['./intercapi-public-layout.component.scss'],
  templateUrl: './intercapi-public-layout.component.html',
  imports: [
    HeaderComponent,
    UserPickerComponent,
    EnvironmentMarkerComponent,
    NavMenuComponent,
    CapNavItemComponent,
    NgStyle,
    CapAlertListComponent,
    FormsModule,
    SearchbarComponent,
    RouterOutlet,
    TranslatePipe,
    NgClass
  ]
})
export class IntercapiPublicLayoutComponent extends AbstractComponent implements OnInit {
  root: MenuTreeItem;

  private imageElementToImagePathMapping: Map<ImageConfigEntry.ElementEnum, string> = new Map();
  private pathsWithoutSearchbar = ['meine-grundstuecke'];

  imagePath: string;
  environmentName: boolean;
  showSearchbar = true;
  disableSearchbar: boolean = false;

  constructor(
    private menuService: AppMenuService,
    private formatService: FormatConfigService,
    private router: Router,
    private loginService: CapiLoginService
  ) {
    super();
    keysToTranslate<string>(['layouts.page.title']);
  }

  ngOnInit(): void {
    this.addSub(
      this.router.events.subscribe(() => {
        this.showSearchbar = !this.pathsWithoutSearchbar.some((path) => this.router.url.includes(path));
      })
    );
    this.addSub(this.menuService.menu$.subscribe((value: MenuTreeItem) => (this.root = value)));
    this.initAppLogo();
    this.addSub(
      this.formatService.parameterConfig$.subscribe((config) => {
        if (<any>config?.parameters.ZUGELASSENE_BENUTZERKATEGORIEN === 'REGISTRIERT') {
          this.disableSearchbar = !this.loginService.userLoggedIn;
        }
      })
    );
    this.addSub(
      this.formatService.settingsConfig$.subscribe((config) => {
        if (config) {
          this.environmentName = !!config.nameUmgebung;
        }
      })
    );
  }

  private initAppLogo(): void {
    this.imageElementToImagePathMapping.set('APP_LOGO_DEFAULT', '');
    this.imageElementToImagePathMapping.set('APP_LOGO_BE', '');
    this.addSub(this.formatService.imageConfig$.subscribe((config) => this.updateLogo(config)));
  }

  private updateLogo(imageConfig: AppImageConfig): void {
    if (!imageConfig) {
      return;
    }
    const configuredImageElement = imageConfig.getImageFormatForCurrentLanguage('APP_LOGO');
    if (configuredImageElement && configuredImageElement.element) {
      this.imagePath = this.imageElementToImagePathMapping.get(configuredImageElement.element);
    }
  }
}
